// extracted by mini-css-extract-plugin
export default {"ReactComponentFullError":"ErrorFeedback-module__ReactComponentFullError--jsmU","ReactComponentError":"ErrorFeedback-module__ReactComponentError--Covp"};